import React from 'react'
import Header from './Header'

const PackageHeader = () => {
    return (
        <div>
            <Header />
        </div>
    )
}

export default PackageHeader
